import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

const ACTION_LABELS = {
  "user.suspend": "Suspended user",
  "user.activate": "Activated user",
  "user.delete": "Deleted user",
  "user.password_reset": "Reset password",
  "question_report.acknowledged": "Acknowledged report",
  "question_report.fixed": "Fixed reported question",
  "question_report.rejected": "Rejected report",
};

export default function AuditLogTab() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs?limit=200").then((r) => setItems(r.data)); }, []);
  return (
    <Card className="border-border/70">
      <CardContent className="p-0">
        <Table>
          <TableHeader><TableRow>
            <TableHead>When</TableHead>
            <TableHead>Actor</TableHead>
            <TableHead>Action</TableHead>
            <TableHead>Target</TableHead>
            <TableHead>Details</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map((e) => (
              <TableRow key={e.id}>
                <TableCell className="text-xs">{new Date(e.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-xs">{e.actor_email}</TableCell>
                <TableCell className="text-xs">{ACTION_LABELS[e.action] || e.action}</TableCell>
                <TableCell className="font-mono text-[10px]">{e.target_type}:{e.target_id.slice(0, 8)}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{e.details?.email || JSON.stringify(e.details || {})}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && (
              <TableRow><TableCell colSpan={5} className="p-10 text-center text-sm text-muted-foreground">No admin actions yet.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
